import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import TextInput from '../../shared/components/TextInput'

@inject('auth') @observer
export default class PaneListNav extends Component {

  static propTypes = {
    activeList: PropTypes.string,
    auth: PropTypes.object.isRequired,
    filter: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }

  @autobind
  handleFilterChanged({ target }) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: 'filter',
          value: target.value,
        },
      })
    }
  }

  @autobind
  handleDistrictChange({ target }) {
    if (this.props.onChange && target.value) {
      this.props.onChange({
        target: {
          name: 'district',
          value: target.value,
        },
      })
    }
  }

  renderRegionSelect() {

    if (!this.props.auth.acs.isAuthorized('SUPERADMIN')) {
      return null
    }

    const districts = window.APP_CONFIG.districts

    return (
      <select
        className="form-control"
        onChange={this.handleDistrictChange}
        value={this.props.activeList}
      >
        <option value="all-districts">Alle Landkreise</option>
        <option value="no-district">Ohne Zuweisung</option>
        <option value="">-----------------------------</option>
        {districts.map((district) => {
          return (
            <option
              key={district.id}
              value={district.id}
            >
              {district.name}
            </option>
          )
        })}
      </select>
    )
  }

  renderSearch() {
    return (
      <TextInput
        size={0}
        type="text"
        value={this.props.filter}
        onChange={this.handleFilterChanged}
        placeholder="Filtern nach Nachname, Vorname..."
      />
    )
  }

  render() {

    if (!(
      this.props.auth.acs.isAuthorized('SUPERADMIN,ADMIN'))
    ) {
      return null
    }

    return (
      <div>
        {this.renderRegionSelect()}
        {this.renderSearch()}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/user/components/PaneListNav.js